import { render } from "./ClienteDebts.vue?vue&type=template&id=7a9c07db&scoped=true"
import script from "./ClienteDebts.vue?vue&type=script&lang=js"
export * from "./ClienteDebts.vue?vue&type=script&lang=js"

import "./ClienteDebts.vue?vue&type=style&index=0&id=7a9c07db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a9c07db"]])

export default __exports__